/**
 * NOTE: This code belongs to Kangaroo Rewards. Unauthorized use is prohibited
 */

@file:Suppress("unused", "MemberVisibilityCanBePrivate")

package js.features.userTransferMessages

import kangaroorewards.appsdk.core.api.Api
import kangaroorewards.appsdk.core.domain.SerializedResult
import kangaroorewards.appsdk.core.domain.toJsonResult
import kotlinx.coroutines.DelicateCoroutinesApi
import kotlinx.coroutines.GlobalScope
import kotlinx.coroutines.promise
import kotlin.js.Promise
import kotlinx.serialization.json.Json
import features.userTransferMessages.TransferMessagesApi
import features.userTransferMessages.models.TransferMessagesModel
import features.userTransferMessages.serializeTransferMessagesState



/**
 * Get this users transfer messages. Transfer messages are points or e-wallet transfers from other users.  [Api] class
 */
@OptIn(DelicateCoroutinesApi::class)
@ExperimentalJsExport
@JsExport
@JsName("TransferMessagesApi")
class TransferMessagesApiJs {

    /**
     * Get this users transfer messages. Transfer messages are points or e-wallet transfers from other users. 
     */
    fun getTransferMessages(
        overrideHeaders: String?, 
        businessId: String
    ): Promise<String?>  {
        return GlobalScope.promise {

        val decodedOverrideHeaders = if (overrideHeaders == null) {
                null
        } else {
            try {
                Json.decodeFromString<Map<String, String>>(overrideHeaders)
            } catch (e: Exception) {
                null
                }
            }

            val result = TransferMessagesApi().getTransferMessages(
            overrideHeaders = decodedOverrideHeaders,
                        businessId = businessId
        ).toJsonResult<TransferMessagesModel>()
        
            return@promise when (result) {
                is SerializedResult.Success -> result.data
                is SerializedResult.UnauthorizedError -> result.error
                is SerializedResult.UnknownError -> result.error
                else -> null
            }
        }
    }

    

    

    fun observeTransferMessagesState(
        onData: (String) -> Unit,
        onStreamError: (String) -> Unit,
    ) {
        TransferMessagesApi().transferMessagesState.serializeTransferMessagesState().observe { result ->
            when (result) {
                is SerializedResult.Idle -> onData(result.state)
                is SerializedResult.Loading -> onData(result.state)
                is SerializedResult.Success -> onData(result.data)
                is SerializedResult.UnauthorizedError -> onData(result.error)
                is SerializedResult.UnknownError -> onData(result.error)
                else -> onStreamError("unknown error in stream")
            }
        }
    }
}
